import { RendererType } from '../../../data-models/field-definition';
import { fundFields, fundFormSchema } from '../../../schemas/Fund.schema';
import { schemaToFormFields } from '../../../util/schema-utils';

export interface IFundConfigFormSchemaOptions {
  /** When the Carta integration has cartaV2 on, fund.cartaId is managed via Integrations → Carta and must not be edited here. */
  cartaManaged?: boolean;
  /** Strategies already in use across the client's funds (`fundStrategiesAtom`), offered as dropdown options; free text stays allowed. */
  strategyOptions?: string[];
}

/**
 * Fund config page schema: the relevant fields picked from the shared fund schema,
 * with the few presentation overrides the config form needs (fundType select renderer,
 * "Vintage Year" label, aliases free-labels renderer). The overrides reuse the shared
 * field builders so validation/defaults stay in sync with the canonical schema.
 */
export function fundConfigFormSchema(options: IFundConfigFormSchemaOptions = {}) {
  const fields = fundFields();
  return fundFormSchema()
    .pick([
      'name',
      'legalName',
      'fundType',
      'vintage',
      'aliases',
      'inceptionDate',
      'cartaId',
      'defaultCurrency',
      'nativeCurrency',
      // 'generalPartners', FIXME FD-3060 - needs FieldUser
      'investmentPeriodEndDate',
      'finalCloseDate',
      'lineOfCredit',
      'strategy',
      'lpNavCalculationType',
    ])
    .shape({
      // generalPartners: fields.generalPartners.formMeta({ renderer: RendererType.freeLabels }),
      fundType: fields.fundType.formMeta({ renderer: RendererType.fundType }),
      vintage: fields.vintage.label('Vintage Year'),
      aliases: fields.aliases.formMeta({ renderer: RendererType.freeLabels }),
      ...(options.strategyOptions && {
        strategy: fields.strategy.formMeta({
          rendererMeta: {
            allowCustomAdd: true,
            values: options.strategyOptions.map((value) => ({ displayName: value, value })),
          },
        }),
      }),
      ...(options.cartaManaged && {
        cartaId: fields.cartaId.formMeta({
          disabled: true,
          label: 'Carta fund ids (managed in Integrations → Carta)',
        }),
      }),
    });
}

export function getFundFields(options: IFundConfigFormSchemaOptions = {}) {
  return schemaToFormFields(fundConfigFormSchema(options));
}
